import { type FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TransportationProviderSelector from '@views/components/Selectors/AsynchSearch/TransportationProviderSelector';
import { Col, Row, Tabs } from 'antd';
import type { DefaultOptionType } from 'antd/es/select';

import type { RootState } from '@/redux/RootReducer';

import Paper from '../../../components/Paper/Paper';
import CarrierClaimsAddressTab from './components/claims-settings-tabs/carrier-claims-address-tab';
import ClaimsSettingsTab from './components/claims-settings-tabs/claims-settings-tab';

const ClaimsSettingsScreen: FC = () => {
  const [carrierKey, setCarrierKey] = useState<number>();
  const [activeTab, setActiveTab] = useState<string>('carrier-information');
  const { companyId } = useSelector((state: RootState) => state.auth.selectedCompany);

  const handleChange = (option: Pick<DefaultOptionType, 'label' | 'value'>) => {
    setCarrierKey(option?.value as number);
  };

  useEffect(() => {
    setCarrierKey(0);
  }, []);

  const tabItems = [
    {
      children: <ClaimsSettingsTab carrierKey={carrierKey} />,
      key: 'carrier-information',
      label: 'Carrier Information',
    },
    {
      children: <CarrierClaimsAddressTab carrierKey={carrierKey} />,
      key: 'carrier-claims-address',
      label: 'Carrier Claims Address',
    },
  ];

  return (
    <Row className="h-100 overflow-hidden d-flex flex-direction-column flex-nowrap">
      <Col className="mb-10">
        <Paper className="p-10 border-radius-bottom-none">
          <Row align="middle" justify="space-between">
            <Col sm={12} md={6}>
              {/* @ts-ignore */}
              <TransportationProviderSelector
                editMode
                label="Transportation Provider"
                name="carrierKey"
                key={companyId}
                // @ts-expect-error
                onChange={handleChange}
              />
            </Col>
          </Row>
        </Paper>
      </Col>
      <Col className="flex-1 custom-scroll-bar">
        <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} className="h-100" />
      </Col>
    </Row>
  );
};

export default ClaimsSettingsScreen;
